<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-2">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("shift.shiftName") }}</label>
          <input
            v-model="model.shift_name"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('shift_name'),
            }"
            :placeholder="$t('shift.shiftName')"
          />
          <div class="invalid-feedback" v-if="errors.has('shift_name')">
            {{ errors.first("shift_name") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-space-y-1">
          <label class="required">{{ $t("shift.shiftType") }}</label>
          <select
            v-model="model.shift_type"
            class="form-control"
            :class="{
              'is-invalid': errors.has('shift_type'),
            }"
          >
            <option :value="null" selected disabled style="display: none">
              {{ $t("select") }}
            </option>
            <option value="Normal">Normal</option>
            <option value="Shift">Shift</option>
            <option value="Rotation">Rotation</option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('shift_type')">
            {{ errors.first("shift_type") }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{ $t("shift.minute_allow") }}</label>
          <input
            v-model="model.minute_allow"
            type="text"
            class="form-control"
            :class="{ 'is-invalid': errors.has('minute_allow') }"
            :placeholder="$t('shift.minute_allow')"
          />
          <div class="invalid-feedback" v-if="errors.has('minute_allow')">
            {{ errors.first("minute_allow") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t("save")
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "branchForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      companies: [],
      model: {
        shift_id: null,
        shift_name: null,
        shift_type: null,
        minute_allow: null,
      },
    };
  },
  computed: {
    ...mapState("humanResource/shift", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/shift/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/shift/update", {
          id: this.edit_data.shift_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.shift_id = this.edit_data.shift_id;
        this.model.shift_name = this.edit_data.shift_name;
        this.model.shift_type = this.edit_data.shift_type;
        this.model.minute_allow = this.edit_data.minute_allow;
      }
    },
  },
};
</script>
